var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-whitepage-plan-alimentaires",
      staticStyle: { "margin-top": "-15px" }
    },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid bg-gradient-bleu",
          staticStyle: { "min-height": "60px", padding: "10px" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              staticStyle: {
                "background-color": "white",
                "font-weight": "bold",
                "font-size": "12px"
              },
              attrs: { alt: "Retour" },
              on: {
                click: function($event) {
                  return _vm.retournerListe()
                }
              }
            },
            [_vm._v("Retour")]
          ),
          _c(
            "button",
            {
              staticClass: "btn ml-2 btn-success text-white",
              staticStyle: { "font-weight": "bold", "font-size": "12px" },
              attrs: { alt: "Dupliquer", disabled: _vm.donneesModifiees },
              on: {
                click: function($event) {
                  return _vm.afficherModalDuplicationPA()
                }
              }
            },
            [_vm._v("Dupliquer")]
          ),
          _c(
            "button",
            {
              staticClass: "btn ml-2 btn-success text-white",
              staticStyle: { "font-weight": "bold", "font-size": "12px" },
              attrs: { alt: "Enregistrer", disabled: !_vm.donneesModifiees },
              on: {
                click: function($event) {
                  return _vm.enregistrer()
                }
              }
            },
            [_vm._v("Enregistrer")]
          )
        ]
      ),
      _c(
        "div",
        {
          key: _vm.key,
          staticClass: "container-fluid no-padding",
          staticStyle: {
            "min-height": "65vh",
            "background-color": "inherit",
            "overflow-y": "scroll"
          }
        },
        [
          _c(
            "table",
            {
              staticClass: "table fixHeight tableMenus",
              staticStyle: { "table-layout": "fixed", display: "contents" }
            },
            [
              _c("thead", [
                _c(
                  "tr",
                  _vm._l(_vm.currentPlan.jours, function(jour, iJour) {
                    return _c("th", { key: iJour }, [
                      _vm._v(
                        " " +
                          _vm._s(jour.jour) +
                          " sur " +
                          _vm._s(_vm.currentPlan.jours.length) +
                          " "
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm.currentPlan.jours
                ? _c(
                    "tbody",
                    [
                      _vm._l(_vm.currentPlan.jours[0].services, function(
                        typeService,
                        iTypeService
                      ) {
                        return [
                          _c("tr", { key: iTypeService }, [
                            _c(
                              "td",
                              {
                                directives: [
                                  {
                                    name: "b-toggle",
                                    rawName: "v-b-toggle",
                                    value: "service-" + iTypeService,
                                    expression: "'service-' + iTypeService"
                                  }
                                ],
                                staticClass: "accordeon",
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "600"
                                },
                                attrs: { colspan: _vm.currentPlan.jours.length }
                              },
                              [
                                _vm._m(0, true),
                                _vm._v(
                                  " " +
                                    _vm._s(typeService.nom) +
                                    " - " +
                                    _vm._s(_vm.currentPlan.nom) +
                                    " "
                                )
                              ]
                            )
                          ]),
                          _c(
                            "b-collapse",
                            {
                              key: iTypeService + "-c",
                              attrs: {
                                tag: "tr",
                                id: "service-" + iTypeService,
                                visible: ""
                              }
                            },
                            _vm._l(_vm.currentPlan.jours, function(
                              jour,
                              iJour
                            ) {
                              return _c(
                                "td",
                                {
                                  key: iJour,
                                  staticStyle: { padding: "0.2rem" }
                                },
                                _vm._l(jour.services, function(
                                  service,
                                  iService
                                ) {
                                  return _c("div", { key: iService }, [
                                    service.serviceId === typeService.serviceId
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "composantes-container",
                                            staticStyle: { width: "250px" }
                                          },
                                          _vm._l(service.composantes, function(
                                            composante,
                                            iComposante
                                          ) {
                                            return _c(
                                              "div",
                                              { key: iComposante },
                                              [
                                                _c("CasePlanAlimentaire", {
                                                  ref:
                                                    "case_" +
                                                    iJour +
                                                    "_" +
                                                    iService +
                                                    "_" +
                                                    iComposante,
                                                  refInFor: true,
                                                  attrs: {
                                                    composante: composante,
                                                    service: service,
                                                    jour: jour,
                                                    categorie: _vm.categorieGEMRCN(
                                                      composante.categorieGEMRCNId
                                                    ),
                                                    limites: _vm.limitesFiltrees(
                                                      _vm.categorieGEMRCN(
                                                        composante.categorieGEMRCNId
                                                      ),
                                                      service
                                                    )
                                                  },
                                                  on: {
                                                    "effacer-categorie":
                                                      _vm.effacerCategorie
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ])
                                }),
                                0
                              )
                            }),
                            0
                          )
                        ]
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.montrerModalCategorie
            ? _c(
                "b-modal",
                {
                  attrs: {
                    size: "lg",
                    "hide-footer": "",
                    "header-bg-variant": "gradient-bleu",
                    "header-text-variant": "light"
                  },
                  on: { hide: _vm.cacherModalCategorie },
                  model: {
                    value: _vm.montrerModalCategorie,
                    callback: function($$v) {
                      _vm.montrerModalCategorie = $$v
                    },
                    expression: "montrerModalCategorie"
                  }
                },
                [
                  _c("template", { slot: "modal-title" }, [
                    _c("h3", { staticStyle: { color: "white" } }, [
                      _vm._v("Ajout de catégorie GEMRCN")
                    ])
                  ]),
                  _c("template", { slot: "default" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 no-padding push-top-1rem" },
                      [
                        _c("h4", [_vm._v(_vm._s(_vm.titreModal))]),
                        _c("MultiSelect", {
                          staticClass: "push-top-1rem push-right-2rem",
                          staticStyle: { width: "100%" },
                          attrs: {
                            value: _vm.composantesModal,
                            items: _vm.composantes,
                            placeholder: "Composantes...",
                            emptyText: "Toutes les composantes ont été ajoutées"
                          },
                          on: {
                            change: function($event) {
                              _vm.composantesModal = $event
                            }
                          }
                        }),
                        _c("label", [_c("b", [_vm._v("Catégorie GEMRCN")])]),
                        _vm._l(_vm.categoriesFiltrees, function(
                          categorie,
                          iCategorie
                        ) {
                          return _c(
                            "div",
                            {
                              key: iCategorie,
                              staticClass: "row",
                              staticStyle: {
                                border: "1px solid lightgray",
                                margin: "0",
                                padding: "5px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectionnerCategorie(categorie)
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "col-1",
                                style:
                                  "border-radius: 5px;background-color:" +
                                  categorie.couleur
                              }),
                              _c(
                                "div",
                                { staticClass: "col-10" },
                                [
                                  _c("div", [_vm._v(_vm._s(categorie.nom))]),
                                  _vm._l(
                                    _vm.limitesFiltrees(
                                      categorie,
                                      _vm.serviceModal
                                    ),
                                    function(limite, iLimite) {
                                      return _c("div", { key: iLimite }, [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              "mt-2 " +
                                              (_vm.limiteEstValide(limite)
                                                ? "text-success"
                                                : "text-danger")
                                          },
                                          [
                                            _vm._v(
                                              "Décompte : " +
                                                _vm._s(limite.compte)
                                            )
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class: _vm.limiteEstValide(limite)
                                              ? "text-success"
                                              : "text-danger"
                                          },
                                          [
                                            _vm._v(
                                              "Recommandation : " +
                                                _vm._s(limite.texteAAfficher)
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  )
                                ],
                                2
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.montrerModalDuplicationPA
            ? _c(
                "b-modal",
                {
                  attrs: {
                    size: "sm",
                    "hide-footer": "",
                    "header-bg-variant": "gradient-bleu",
                    "header-text-variant": "light"
                  },
                  on: { hide: _vm.cacherModalDuplicationPA },
                  model: {
                    value: _vm.montrerModalDuplicationPA,
                    callback: function($$v) {
                      _vm.montrerModalDuplicationPA = $$v
                    },
                    expression: "montrerModalDuplicationPA"
                  }
                },
                [
                  _c("template", { slot: "modal-title" }, [
                    _c("h3", { staticStyle: { color: "white" } }, [
                      _vm._v("Duplication")
                    ])
                  ]),
                  _c("template", { slot: "default" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 no-padding push-top-1rem" },
                      [
                        _c("label", [
                          _c("b", [_vm._v("Nom du plan de destination")])
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.nomNouveauPlanAlimentaire,
                              expression: "nomNouveauPlanAlimentaire",
                              modifiers: { trim: true }
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { type: "text" },
                          domProps: { value: _vm.nomNouveauPlanAlimentaire },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.nomNouveauPlanAlimentaire = $event.target.value.trim()
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _c("div", { staticClass: "flex-end" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn ml-2 mt-3 btn-primary",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "12px"
                              },
                              attrs: { alt: "Dupliquer" },
                              on: {
                                click: function($event) {
                                  return _vm.dupliquer()
                                }
                              }
                            },
                            [_vm._v("Dupliquer")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn ml-2 mt-3 btn-primary",
                              staticStyle: {
                                "font-weight": "bold",
                                "font-size": "12px"
                              },
                              attrs: { alt: "Annuler" },
                              on: {
                                click: function($event) {
                                  return _vm.cacherModalDuplicationPA()
                                }
                              }
                            },
                            [_vm._v("Annuler")]
                          )
                        ])
                      ]
                    )
                  ])
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-chevron-up" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }